module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"title":"Units Per Transaction"}}')
  delete Component.options._Ctor
}
